import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import moment from 'moment';

import ImageFileContext from '../../modules/contexts/ImageFile';
import * as api from '../../lib/api/api';
import * as PATH from '../../lib/routes/path';
import BabyfaceOrderTemplate from '../../components/common/template/BabyfaceOrderTemplate';
import {
  AllowMarketingInduceModal,
  AllowMarketingNotiModal,
  doConfirmAllowMarketing,
  ORDER_INDUCE,
} from '../../components/common/organism/AllowMarketing';
import OrderLoading from '../../components/common/molecules/OrderLoading';
import { convertAllEmojiToHeartEmoji } from '../../modules/reducers/MessageReducer';
import {
  ERROR_REFRESH,
  ERROR_VALIDATE_ORDER,
  STATUS_MESSAGE,
} from '../../lib/Error';
import { onHandleInvalidFieldError } from '../../Hooks/useError';
import { IMP_CODE, isPG } from '../../lib/PaymentInfo';
import { doChangeUserAllowMarketing } from '../../lib/util/userContract';

const IMP = window.IMP;
IMP.init(IMP_CODE);

class OrderContainer extends Component {
  static contextType = ImageFileContext;
  state = {
    pg: 'html5_inicis',
    message: '',
    note: '',
    name: '',
    mobile: '',
    zipcode: '',
    address: '',
    detailAddress: '',
    babyGender: null,
    hospitalName: sessionStorage.be_hospital || '',
    pay_method: 'card',
    merchant_uid: '',
    finalPrice: 0,
    loading: false,
    voucherId: '',
    frames: null,
    selectedFrame: 'DEFAULT',
    previewFrame: null,
    previewFrameName: null,
    voucherIds: [],
    defaultPrice: 0,
    finalShippingFee: 0,
    shipmentRequired: false,
    refundAccount: '',
    refundBank: '',
    refundHolder: '',
    textarea: null,
    contract: {},
    allowMarketingInitialValue: false,
  };
  affiliateContext = this.props.affiliateContext;

  componentDidMount() {
    this.handleGetFrame();
    this.getBuyerInfo();
    this.getOrderInfo();
    this.checkStatus();
  }

  handleSelectVoucherCoupon = (voucherCouponList, onSetSelectedVoucherCoupon, setIsLoading) => {
    const itemId = sessionStorage.itemId;
    const optionIds = JSON.parse(sessionStorage.optionIds);

    if (setIsLoading) setIsLoading(true);
    api
      .tempPrice({
        itemId,
        voucherIds: voucherCouponList,
        optionIds,
        includeShippingFee: true,
      })
      .then((response) => {
        onSetSelectedVoucherCoupon(voucherCouponList);
        this.setState((prevState) => ({
          finalPrice: response.data.finalPrice,
          defaultPrice: response.data.defaultPrice,
          finalShippingFee: response.data.finalShippingFee,
          shipmentRequired: response.data.shipmentRequired,
          voucherIds: voucherCouponList,
        }));
        if (sessionStorage.accessToken && !this.state.address) {
          this.getPreviousOrderHistory();
        }
      })
      .catch((error) => {
        const {
          status,
          data: { invalidValue },
        } = error.response;
        status === 400
          ? alert(invalidValue)
          : status === 409
          ? alert(STATUS_MESSAGE.order.testPrice[status])
          : alert(ERROR_REFRESH);
      }).finally(() => {
        if (setIsLoading) setIsLoading(false);
      });
  };

  handleSelectAccount = (e) => {
    this.setState({
      refundBank: e.value,
    });
  };

  handleGetAccountHolder = () => {
    const statusMessage = STATUS_MESSAGE.order.refund;
    const { refundAccount, refundBank, refundHolder } = this.state;
    if (refundAccount === '' || refundBank === '' || refundHolder === '') {
      alert(statusMessage.REQUIRE_VALIDATION);
    } else {
      api
        .getAccountHolder({
          bankCode: refundBank,
          accountNumber: refundAccount,
        })
        .then((response) => {
          const {
            code,
            message,
            response: { accountHolder },
          } = response.data;
          if (code === 0) {
            if (accountHolder === refundHolder) {
              this.handleSubmit();
            } else {
              alert(statusMessage[200]);
            }
          } else {
            alert(message);
          }
        });
    }
  };

  handleGetFrame = () => {
    api.getFrames().then((response) => {
      const frames = response.data;
      const { selectedFrame } = this.state;
      const defaultFrame = frames.find(
        (frame) => frame.alias === selectedFrame,
      );
      const previewFrame = defaultFrame.previewImage.storageUri;
      const previewFrameName = defaultFrame.meta.name;
      this.setState({
        frames,
        selectedFrame,
        previewFrame,
        previewFrameName,
      });
    });
  };

  getBuyerInfo = () => {
    const id = sessionStorage._id;
    api.getInfo({ id }).then((response) => {
      const tempMobile =
        response.data.contactInfo === null
          ? ''
          : response.data.contactInfo.mobile === null
          ? ''
          : response.data.contactInfo.mobile;
      this.setState({
        email: response.data.email,
        name: response.data.name,
        mobile: tempMobile,
        contract: response.data.contract,
        allowMarketingInitialValue: response.data.contract.allowMarketing,
      });
    });
  };

  getOrderInfo = () => {
    const itemId = sessionStorage.itemId;
    const optionIds = JSON.parse(sessionStorage.optionIds);
    const voucherIds = this.state.voucherIds;
    api
      .tempPrice({ itemId, voucherIds, optionIds, includeShippingFee: true })
      .then((response) => {
        this.setState({
          finalPrice: response.data.finalPrice,
          defaultPrice: response.data.defaultPrice,
          finalShippingFee: response.data.finalShippingFee,
          shipmentRequired: response.data.shipmentRequired,
        });
      });
  };

  getPreviousOrderHistory = () => {
    api.getOrderCheckBefore().then((response) => {
      const { zipcode, address, detailAddress, mobile } = response.data;
      const doCheckNull = (value) => (value ? value : '');

      if (this.state.shipmentRequired) {
        this.setState({
          zipcode: doCheckNull(zipcode),
          address: doCheckNull(address),
          detailAddress: doCheckNull(detailAddress),
          mobile,
        });
      } else {
        this.setState({
          mobile,
        });
      }
    });
  };

  handleTip = (name) => {
    this.setState({
      [name]: !this.state[name],
    });
  };

  handleChange = (e) => {
    // 아기에게 보내는 메시지의 경우 특정 기호를 제외하고는 모두 하트 처리.
    if (e.target.name === 'message') {
      const messageToBaby = convertAllEmojiToHeartEmoji(e.target.value);
      this.setState({ [e.target.name]: messageToBaby });
      return;
    }
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  addHeart = (e) => {
    if (this.state.message.length >= 20) return;
    this.setState({
      message: this.state.message.concat(
        e.target.innerText === 'favorite_border' ? '♡' : '♥',
      ),
    });
  };

  selectGender = (e) => {
    this.setState({
      babyGender: e.target.value,
    });
  };

  handleAllowMarketing = (allowMarketing, setChecked = () => {}) => {
    const { contract } = this.state;

    if (doConfirmAllowMarketing(contract.allowMarketing)) {
      doChangeUserAllowMarketing({
        contract,
        allowMarketing,
        afterChangeContract: (data) => {
          const { contract, updateDateTime } = data;

          this.setState({ contract });
          setChecked(contract.allowMarketing);

          this.props.onModal({
            title: '마케팅 동의 안내',
            content: (
              <AllowMarketingNotiModal
                updateDateTime={updateDateTime}
                allowMarketing={contract.allowMarketing}
              />
            ),
          });
        },
      });
    }
  };

  handleCheckMessage = () => {
    const text = this.state.message;

    api.checkMessage({ text }).then((response) => {
      if (response.data === '') {
        if (this.state.pay_method === 'vbank') {
          this.handleGetAccountHolder();
        } else {
          this.handleSubmit();
        }
      } else {
        alert(`메시지에 ${response.data} 이모티콘은 사용하실 수 없습니다.`);
      }
    });
  };

  handleCheck = () => {
    if (this.context.state.ultraList.length < 1) {
      return alert(ERROR_VALIDATE_ORDER.ultrasound);
    }

    if (this.state.shipmentRequired && (
      !this.state.detailAddress ||
      !this.state.name ||
      !this.state.mobile ||
      !this.state.address)
    ) {
      return alert('배송지 정보를 확인해주세요.');
    } else if (!this.state.shipmentRequired && (
      !this.state.name ||
      !this.state.mobile)
    ) {
      return alert('신청자 정보를 확인해주세요.');
    }

    if (this.state.contract.allowMarketing) {
      this.handleCheckMessage();
    } else {
      this.props.onModal({
        title: ORDER_INDUCE.title,
        content: (
          <AllowMarketingInduceModal
            allowMarketing={this.state.contract.allowMarketing}
            onClick={(setChecked) =>
              this.handleAllowMarketing(
                !this.state.contract.allowMarketing,
                setChecked,
              )
            }
            modalText={ORDER_INDUCE.text}
          />
        ),
        buttonText: '동의하지 않고 결제하기',
        afterConfirmEvent: this.handleCheckMessage,
      });
    }
  };

  /**
   * DB 에 결제 정보 기입
   */
  handleSubmit = async () => {
    const {
      email,
      name,
      mobile,
      zipcode,
      address,
      detailAddress,
      message,
      note,
      babyGender,
      hospitalName,
      selectedFrame,
      voucherIds,
      refundAccount,
      refundBank,
      refundHolder,
    } = this.state;
    const paymentMethod =
      this.state.pay_method === 'card'
        ? 'CREDIT_CARD'
        : this.state.pay_method === 'vbank'
        ? 'VIRTUAL_ACCOUNT'
        : this.state.pg === 'kakaopay'
        ? 'KAKAO_PAY'
        : 'NONE';
    const itemId = sessionStorage.itemId;
    const optionIds = JSON.parse(sessionStorage.optionIds);

    this.setState({
      loading: true,
    });
    if (this.state.pay_method === 'vbank') {
      api
        .createOrder({
          email,
          name,
          mobile,
          zipcode,
          address,
          detailAddress,
          message,
          note,
          itemId,
          optionIds,
          babyGender,
          hospitalName,
          voucherIds,
          paymentMethod,
          selectedFrame,
          refundAccount,
          refundBank,
          refundHolder,
        })
        .then((response) => {
          this.setState(
            {
              merchant_uid: response.data.paymentKey,
            },
            () => {
              const reqId = response.data.items[0].id;
              this.babyUploadHandler({ reqId });
            },
          );
        })
        .catch((error) => {
          onHandleInvalidFieldError({
            error,
            errorMsg: STATUS_MESSAGE.order,
          });
          this.setState({
            loading: false,
          });
        });
    } else {
      api
        .createOrder({
          email,
          name,
          mobile,
          zipcode,
          address,
          detailAddress,
          message,
          note,
          itemId,
          optionIds,
          babyGender,
          hospitalName,
          voucherIds,
          paymentMethod,
          selectedFrame,
        })
        .then((response) => {
          this.setState(
            {
              merchant_uid: response.data.paymentKey,
            },
            () => {
              const reqId = response.data.items[0].id;
              this.babyUploadHandler({ reqId });
            },
          );
        })
        .catch((error) => {
          onHandleInvalidFieldError({
            error,
            errorMsg: STATUS_MESSAGE.order,
          });
          this.setState({
            loading: false,
          });
        });
    }
  };

  babyUploadHandler = ({ reqId }) => {
    const message = STATUS_MESSAGE.order.babyUpload;
    const ultraFilesList = this.context.state.ultraList;
    let fd = new FormData();
    for (let i = 0; i < ultraFilesList.length; i++) {
      let file = ultraFilesList[i];
      fd.append('files', file, file.name);
    }
    return api
      .uploadUltra({ reqId, fd })
      .then((response) => {
        // 크롬 팝업 차단 정책 대응: setTimeout을 사용하여 이벤트 루프의 다음 틱에서 실행
        // 사용자 제스처(클릭)를 보존하기 위해 즉시 실행
        setTimeout(() => {
          this.requestPay();
        }, 0);
      })
      .catch((error) => {
        alert(message);
        this.setState({
          loading: false,
        });
      });
  };

  requestPay = () => {
    const message = STATUS_MESSAGE.order.requestPay;
    if (this.state.finalPrice === 0) {
      this.affiliateContext.actions.setIsAffiliateOutlink(false);
      this.setState({
        toCompletion: true,
      });
    } else {
      const mobile = this.state.mobile.replace(/[^0-9]/g, '');
      // 크롬 팝업 차단 정책 대응: 클릭 이벤트 내에서 즉시 호출
      // IMP.request_pay(param, callback) 호출
      try {
        IMP.request_pay(
          {
            // param
            pg: this.state.pg,
            pay_method: this.state.pay_method,
            merchant_uid: this.state.merchant_uid,
            name: '베이비페이스',
            amount: this.state.finalPrice,
            buyer_email: this.state.email,
            buyer_name: this.state.name,
            buyer_tel: mobile,
            buyer_addr: this.state.address + ' ' + this.state.detailAddress,
            notice_url: `${process.env.REACT_APP_BACKEND_URL}/any/payment/iamport`,
            m_redirect_url: `${process.env.REACT_APP_ORIGIN_URL}/order`,
            vbank_due: moment().clone().add(3, 'day').format('YYYYMMDDhhmm'),
          },
          (rsp) => {
            if (rsp.success) {
              const paymentKey = rsp.merchant_uid;
              let i = 0;
              const loop = () => {
                i += 1;
                api.getPaymentInfo(paymentKey).then((response) => {
                  if (
                    response.data.status === 'PAID' ||
                    response.data.status === 'PENDING_DEPOSIT'
                  ) {
                    this.affiliateContext.actions.setIsAffiliateOutlink(false);
                    this.setState({
                      toCompletion: true,
                    });
                    clearInterval(handler);
                  }
                });
                if (i === 7) {
                  clearInterval(handler);
                  api.putForceRefund(paymentKey);
                  alert(message.FAIL);
                  this.setState({
                    loading: false,
                  });
                }
              };
              const handler = setInterval(loop, 3000);
            } else {
              alert(`${message.FAIL} 에러 내용: ${rsp.error_msg}`);
              this.setState({
                loading: false,
              });
            }
          },
        );
      } catch (error) {
        console.error('결제창 호출 오류:', error);
        alert(`${message.FAIL} 결제창을 열 수 없습니다. 다시 시도해주세요.`);
        this.setState({
          loading: false,
        });
      }
    }
  };

  checkStatus = () => {
    const message = STATUS_MESSAGE.order.requestPay;
    if (this.props.status === 'true') {
      const merchant_uid = this.props.merchant_uid;
      const paymentKey = merchant_uid;
      this.setState({
        loading: true,
        merchant_uid: paymentKey,
      });
      let a = 0;
      const loop = () => {
        a += 1;
        api.getPaymentInfo(paymentKey).then((response) => {
          if (
            response.data.status === 'PAID' ||
            response.data.status === 'PENDING_DEPOSIT'
          ) {
            this.affiliateContext.actions.setIsAffiliateOutlink(false);
            this.setState({
              toCompletion: true,
            });
            clearInterval(handler);
          }
        });
        if (a === 3) {
          clearInterval(handler);
          api.putForceRefund(paymentKey);
          alert(message.FAIL);
          this.setState({
            loading: false,
          });
        }
      };
      const handler = setInterval(loop, 3000);
    } else if (this.props.status === 'false') {
      alert(`${message.FAIL} 에러 내용: ${this.props.errorMSG}`);
    } else {
      return null;
    }
  };

  handlePayMethod = (e) => {
    const value = e.target.value;

    this.setState({
      pg: isPG(value) ? value : 'html5_inicis',
      pay_method: isPG(value) ? '' : value,
    });
  };

  handleSelectFrame = ({ selectedFrame, previewImage, previewFrameName }) => {
    this.setState({
      selectedFrame: selectedFrame,
      previewFrame: previewImage,
      previewFrameName: previewFrameName,
    });
  };

  handleAddress = ({ address, zipcode }) => {
    this.setState({
      address,
      zipcode,
    });
  };
  render() {
    return (
      <>
        {this.state.toCompletion && (
          <Redirect to={`${PATH.COMPLETION}/${this.state.merchant_uid}`} />
        )}
        {this.state.loading ? (
          <OrderLoading />
        ) : (
          <>
            <BabyfaceOrderTemplate
              message={this.state.message}
              note={this.state.note}
              name={this.state.name}
              mobile={this.state.mobile}
              zipcode={this.state.zipcode}
              address={this.state.address}
              detailAddress={this.state.detailAddress}
              babyGender={this.state.babyGender}
              hospitalName={this.state.hospitalName}
              pay_method={this.state.pay_method}
              finalPrice={this.state.finalPrice}
              onChange={this.handleChange}
              onClickAddHeart={this.addHeart}
              onAddress={this.handleAddress}
              selectGender={this.selectGender}
              onCheck={this.handleCheck}
              onPayMethod={this.handlePayMethod}
              pg={this.state.pg}
              frames={this.state.frames}
              onSelectFrame={this.handleSelectFrame}
              previewFrame={this.state.previewFrame}
              selectedFrame={this.state.selectedFrame}
              previewFrameName={this.state.previewFrameName}
              onSelectVoucherCoupon={this.handleSelectVoucherCoupon}
              defaultPrice={this.state.defaultPrice}
              finalShippingFee={this.state.finalShippingFee}
              shipmentRequired={this.state.shipmentRequired}
              onSelectAccount={this.handleSelectAccount}
              allowMarketing={this.state.contract.allowMarketing}
              allowMarketingInitialValue={this.state.allowMarketingInitialValue}
              handleAllowMarketing={this.handleAllowMarketing}
            />
          </>
        )}
      </>
    );
  }
}

export default OrderContainer;
